/* Vikst Best Sellers — carousel arrows, per-card image switching, reveal.
   Static and cacheable: it finds its own sections instead of being emitted
   inline per instance, which also keeps the section file under the theme
   API's 16KB write limit. */

(function () {
  if (window.__vikstBsInit) return;
  window.__vikstBsInit = true;

  function init(root) {
    if (!root || root.dataset.bsInit) return;
    root.dataset.bsInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Reveal. The class is added here, not in the markup, so the cards are
       never left hidden if this script does not run. */
    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('bs-anim');
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          root.classList.add('is-revealed');
          io.disconnect();
          return;
        }
      }, { threshold: 0.08 });
      io.observe(root);
      /* Safety net in case the observer never fires. */
      window.setTimeout(function () { root.classList.add('is-revealed'); }, 2500);
    }

    /* Per-card image switching. */
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-card-prev],[data-card-next]');
      if (!btn) return;
      event.preventDefault();

      var media = btn.closest('.vikst-bs__media');
      if (!media) return;
      var imgs = media.querySelectorAll('.vikst-bs__img');
      if (imgs.length < 2) return;

      var current = media.querySelector('.vikst-bs__img.is-active');
      if (!current) return;
      var index = Array.prototype.indexOf.call(imgs, current);
      var step = btn.hasAttribute('data-card-next') ? 1 : -1;

      current.classList.remove('is-active');
      imgs[(index + step + imgs.length) % imgs.length].classList.add('is-active');
    });

    /* Carousel arrows. */
    var track = root.querySelector('.vikst-bs__track');
    var prev = root.querySelector('[data-bs-prev]');
    var next = root.querySelector('[data-bs-next]');
    if (!track || !prev || !next) return;

    var rtl = getComputedStyle(track).direction === 'rtl';

    function stepSize() {
      var card = track.querySelector('.vikst-bs__card');
      if (!card) return track.clientWidth * 0.85;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var pos = Math.abs(track.scrollLeft);
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.classList.toggle('is-disabled', pos <= 0);
      next.classList.toggle('is-disabled', pos >= max);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: rtl ? stepSize() : -stepSize(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: rtl ? -stepSize() : stepSize(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    var roots = document.querySelectorAll('.vikst-bs');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Theme editor re-renders sections without a full page load. */
  document.addEventListener('shopify:section:load', boot);
})();